<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { type AlertVariants, alertVariants } from '@/components/ui/Alert/index';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  variant?: AlertVariants['variant'];
  testId?: string;
}>();
</script>

<template>
  <div :class="cn(alertVariants({ variant }), props.class)" role="alert" :data-testid="props.testId">
    <slot />
  </div>
</template>
